import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import FalconRoutes from "routes";

const App = () => {
  // useAxiosSetup();

  // const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  // const {
  //   config: { navbarPosition },
  // } = useAppContext();

  // useEffect(() => {
  //   if (is.windows()) {
  //     HTMLClassList.add("windows");
  //   }
  //   if (is.chrome()) {
  //     HTMLClassList.add("chrome");
  //   }
  //   if (is.firefox()) {
  //     HTMLClassList.add("firefox");
  //   }
  //   if (is.safari()) {
  //     HTMLClassList.add("safari");
  //   }
  // }, [HTMLClassList]);

  // useEffect(() => {
  //   if (navbarPosition === "double-top") {
  //     HTMLClassList.add("double-top-nav-layout");
  //   }
  //   return () => HTMLClassList.remove("double-top-nav-layout");
  // }, [navbarPosition]);

  return (
    <Router>
      <FalconRoutes />
      {/* <SettingsToggle />
      <SettingsPanel /> */}
      <ToastContainer
        // closeButton={CloseButton}
        // icon={false}
        position={toast.POSITION.BOTTOM_RIGHT}
      // toastClassName="custom-toast-container"
      // toastContainerClassName="custom-toast-container"
      />
    </Router>
  );
};

export default App;
